import { GalaxyFilterOperator } from './enums';

export const filterOperatorToLabel: Record<GalaxyFilterOperator, string> = {
  [GalaxyFilterOperator.FILTER_OPERATOR_INVALID]: 'GALAXY.FILTER.CHIP.OPERATOR.INVALID',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_EMPTY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_EMPTY',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_EMPTY',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS]: 'GALAXY.FILTER.CHIP.OPERATOR.IS',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_ANY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_ANY',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_ANY]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_ANY',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_ALL]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_ALL',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_ALL]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_ALL',
  [GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS]: 'GALAXY.FILTER.CHIP.OPERATOR.CONTAINS',
  [GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN]: 'GALAXY.FILTER.CHIP.OPERATOR.DOES_NOT_CONTAIN',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_EQUAL_TO]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_EQUAL_TO',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EQUAL_TO]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_EQUAL_TO',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_GREATER_THAN',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO]:
    'GALAXY.FILTER.CHIP.OPERATOR.IS_GREATER_THAN_OR_EQUAL_TO',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_LESS_THAN',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO]:
    'GALAXY.FILTER.CHIP.OPERATOR.IS_LESS_THAN_OR_EQUAL_TO',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_BEFORE]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BEFORE',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_BEFORE_OR_ON]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BEFORE_OR_ON',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_AFTER]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_AFTER',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_AFTER_OR_ON]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_AFTER_OR_ON',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_BETWEEN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_BETWEEN',
  [GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_BETWEEN]: 'GALAXY.FILTER.CHIP.OPERATOR.IS_NOT_BETWEEN',
};
